import { Environment } from "@coxauto-ui/cxm/communications/interfaces";
import { fetchWrapper } from "@coxauto-ui/core-http";
import { getBaseUrl, getHeader } from "../config";
import { ResponseError } from "./interfaces/api-error";
import {
  PostMediaEndlinkRequest,
  PostMediaEndlinkResponse
} from "./interfaces/post-media-endlink";

export async function postMediaEndlink(
  data: PostMediaEndlinkRequest,
  env: Environment
): Promise<PostMediaEndlinkResponse | ResponseError> {
  const url = `${getBaseUrl(env)}cxm/media/endlink`;
  const header = await getHeader();

  try {
    const response = await fetchWrapper.postAsync<PostMediaEndlinkResponse>(
      url,
      data,
      header
    );

    if (response && !response.hasError && response.data) {
      return response.data;
    }

    const error: ResponseError = {
      isError: true,
      statusCode: response.statusCode,
      errorResult: response.error
    };
    return error;
  } catch {
    return {
      isError: true,
      statusCode: 0,
      errorResult: { message: "Network error" }
    } as ResponseError;
  }
}
